import React from 'react';
import { businessServices } from '../data/businessServices';
import ServiceSection from '../components/ServiceSection';

const Business = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 hero-pattern relative overflow-hidden">
        <div className="container mx-auto text-center relative z-10">
          <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-lg p-8 rounded-2xl border border-white/10">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
              Soluții Complete pentru Afacerea Ta
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-white/80">
              Servicii profesionale de telecomunicații pentru companiile care vizează performanța
            </p>
            <button className="bg-primary-light hover:bg-blue-600 text-white font-bold py-4 px-8 rounded-lg text-lg transition duration-300 transform hover:scale-105">
              Solicită o Ofertă
            </button>
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/50 to-primary opacity-90"></div>
      </section>

      {/* Service Sections */}
      {businessServices.map((service, index) => (
        <ServiceSection key={service.title} service={service} index={index} showPackages={false} />
      ))}

      {/* Contact Section */}
      <section className="py-20 px-4 bg-gray-100">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">Contactează Echipa Business</h2>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <form className="space-y-6">
                <div>
                  <label className="block text-gray-700 mb-2" htmlFor="company">
                    Numele Companiei
                  </label>
                  <input
                    type="text"
                    id="company"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2" htmlFor="name">
                    Persoana de Contact
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2" htmlFor="phone">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2" htmlFor="message">
                    Mesaj
                  </label>
                  <textarea
                    id="message"
                    rows={4}
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary-dark transition duration-300"
                >
                  Trimite Mesajul
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Business;